import data from '../codigosMexico.json'

export const obtenerCodigoPostal = (provincia) => {

    if (!provincia) {

        return 0
    }

    let estados = data.filter(item => item.province === provincia);

    if (estados.length > 0) {
        return estados[0].zipcode
    }else{
        return 0
    }

}